<template>
  <div class="design p-2">
    <nav class="navbar fill justify-content-between align-items-center m-5">
      <h3 class="mb-0 sign ml-5">
        Sign Up Now for our Discount
        <br />Product
      </h3>
      <form class="form-inline">
        <input
          class="form-control mr-sm-2 py-4 pr-5 transparent"
          placeholder="mailto@youmail.com"
          aria-label="Search" type="email" required
        />
        <button class="btn click my-2 my-sm-0 px-5" type="submit">Submit</button>
      </form>
    </nav>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/page1/form.vue